import { BILLING_STATUS } from "@core/constants";
import { EtabProfileModel, IEtabProfile } from "@core/models";

export const basicEtabProfileMock = new EtabProfileModel();

export const AEEtabProfileMock = new EtabProfileModel({
  [IEtabProfile.billing]: 1,
  [IEtabProfile.billingStatus]: BILLING_STATUS.AE,
});
